import { configureStore } from '@reduxjs/toolkit';
import jobDetailsReducer from './slices/jobDetailsSlice'; // Import the slice reducer
import jobManagementReducer from './slices/jobManagementSlice';
import jobListReducer from './slices/jobListSlice';
import historyReducer from './slices/historySlice'; // Import the history slice reducer
import applicantDetailsReducer from './slices/applicantDetailsSlice';
import assignedJobReducer from './slices/assignedJobSlice';
const store = configureStore({
  reducer: {
    jobDetails: jobDetailsReducer, // Register the slice reducer
    jobManagement: jobManagementReducer,
    jobList: jobListReducer,
    history: historyReducer, // Register the history slice reducer
    applicantDetails: applicantDetailsReducer,
    assignedJobs: assignedJobReducer,
  },
});

export default store;
